import { ChakraProvider } from "@chakra-ui/react";
import { AnalyticsProvider } from "@superbright/indexeddb-orm";
import type { ReactNode } from "react";

import { useBootstrap } from "api/bootstrap/useBootstrap";
import { useVisitorSession } from "api/visitor-session";
import { ExternalServicesProvider } from "features/ExternalServices/context";
import { theme } from "theme";
import { getSlugFromPathname } from "utils";
import { runtimeEnv } from "utils/runtimeEnv";

export function InnerProviders({ children }: { children: ReactNode }) {
  const slug = getSlugFromPathname();
  const visitor_uuid = useVisitorSession(slug);
  useBootstrap(slug, visitor_uuid);

  const envMode = import.meta.env.MODE ?? "production";
  const mixpanelToken = runtimeEnv.VITE_MIXPANEL_TOKEN();
  const posthogKey = runtimeEnv.VITE_POSTHOG_KEY();
  const posthogHost = runtimeEnv.VITE_POSTHOG_HOST();

  return (
    <AnalyticsProvider
      visitor_uuid={visitor_uuid}
      mixpanelToken={mixpanelToken}
      envMode={envMode}
      posthogKey={posthogKey}
      posthogHost={posthogHost}
    >
      <ChakraProvider value={theme}>
        <ExternalServicesProvider>{children}</ExternalServicesProvider>
      </ChakraProvider>
    </AnalyticsProvider>
  );
}
